import Components from "../components";
import moment from "moment";

// The Timer component is used to automatically increment
// time-ago style timestamps for pages refreshed automatically.
// Without something like this, the uptime details page always says
// "checked a few seconds ago" because it's automatically updated
// after each check.
class Timer extends Components.Base {
  bind() {
    this.tick();
    this.interval = window.setInterval(() => this.tick(), 60 * 1000);
  }

  unbind() {
    window.clearInterval(this.interval);
  }

  tick() {
    this.$el.html(moment.unix(this.$el.data("start")).fromNow());
  }
}

Components.collection.register({ selector: ".c-timer", klass: Timer });
